// 页面类型
export const pageType = {
  homePage: 'homePage', //首页
  smartOrderPage: 'smartOrderPage', //智能工单提交页
  faqListPage: 'faqListPage', // faq列表页
  searchPage: 'searchPage', // 搜索页
  faqDetailPage: 'faqDetailPage', // faq详情页
  orderListPage: 'orderListPage', // 工单列表页
  orderDetailPage: 'orderDetailPage', // 工单详情页
  orderCreatePage: 'orderCreatePage', // 创建新工单页
  accountDeletePage: 'accountDeletePage' // 账号删除页
};

// 弹窗类型
export const popupType = {
  emailSubscribePopup: 'emailSubscribePopup', // 邮件订阅弹窗
  noticePopup: 'noticePopup' // 通知弹窗
};

// 按钮触发位置
export const locationType = {
  ...pageType,
  ...popupType
};

/**
  页面展示
  key: 页面类型key
  */
export const viewPage = key => {
  window?.officialSupportDataLayer?.push({
    eventName: 'view_page',
    eventType: pageType[key] || key || ''
  });
};

/**
  弹窗展示
  popupType: 描述弹窗类型
  */
export const showPopup = key => {
  window?.officialSupportDataLayer?.push({
    eventName: 'show_popup',
    eventType: popupType[key] || key || ''
  });
};

/**
  按钮点击
  btnName: 按钮名称
  reason: 按钮所属模块
  */
export const clickButton = ({ btnName, locationKey, otherParams }) => {
  window?.officialSupportDataLayer?.push({
    eventName: 'click_button',
    eventType: btnName || '',
    eventReason: locationType[locationKey] || locationKey || '',
    eventValue: otherParams
  });
};

/**
 * 智能工单增强事件（旧表单 order_version=1；V2 为 2）
 * - view_page + eventValue.exposeStage=formReady：模板加载成功曝光
 * - load_form_fail：拉模板失败
 * - submit_order_fail：校验失败 / 提交接口失败（failType: validate|api）
 */
export const SMART_ORDER_FAIL_TYPE = {
  validate: 'validate',
  api: 'api',
  load: 'load'
};
/** @deprecated 使用 SMART_ORDER_FAIL_TYPE */
export const SMART_ORDER_V2_FAIL_TYPE = SMART_ORDER_FAIL_TYPE;

export const SUPPORT_CENTER_VERSION_SOURCE = {
  api: 'api',
  urlForce: 'url_force',
  cache: 'cache',
  failFallback: 'fail_fallback',
  skippedWorktemp: 'skipped_worktemp'
};

/**
 * 客服中心灰度结算（getSupportCenterVersion）
 * eventType = 页面最终版本；eventReason = 来源
 */
export const trackSupportCenterVersion = ({
  apiVersion,
  resolvedVersion,
  source,
  isLogin,
  gameId,
  result,
  errmsg
} = {}) => {
  const point = {
    eventName: 'support_center_version',
    eventType: String(resolvedVersion ?? ''),
    eventReason: source || '',
    eventValue: {
      apiVersion: apiVersion == null ? '' : String(apiVersion),
      resolvedVersion,
      source,
      isLogin: !!isLogin,
      gameId: gameId || '',
      result: result == null ? '' : String(result),
      errmsg: errmsg || ''
    }
  };
  window.__lastSupportCenterVersionTrack = point;
  window?.officialSupportDataLayer?.push(point);
};

/**
  各模块停留时长
  locationKey: 页面
  duration: 展示总时长
  */
export const sendStayTime = ({ locationKey, duration }) => {
  window?.officialSupportDataLayer?.push({
    eventName: 'stay_time',
    eventType: locationType[locationKey] || locationKey || '',
    eventValue: {
      duration
    }
  });
};
